<div class="container-agenda-event" *ngFor="let event of listEventsAgenda; let i = index" [class.tile-hovered]="hoveredIndex === i">
    <div class="agenda-content" (dblclick)="redirectToPatient(event)" (mouseenter)="hoveredIndex = i"
         (mouseleave)="hoveredIndex = null">
        <div class="icon-calendar-container" [ngStyle]="{ 'border-color': getEventColor(event) }">
            <frg-inline-svg [fill]="getEventColor(event)" stroke="none" class="icon-calendar"
                src="assets/icons/calendar.svg">
            </frg-inline-svg>
        </div>
        <div class="info-agenda-body" >
            <p *ngIf="event.status" class="status">{{event.status.label}}</p>
            <div *ngIf="event.patient" class="infos-agenda-event">
                <p><span>{{event.dateDebut | date:"H:mm"}} - {{ event.patient.nom }} {{ event.patient.prenom }}</span>
                    {{event.patient.dateNaissance}}</p>
            </div>
            <p class="description">{{event.description ? event.description : ''}}</p>
        </div>

    </div>
    <div class="options-buttons">
        <button class="vu" (click)="changeEventStatut(event)" title='Marquer comme "vu"'></button>
        <!-- <button class="edit-rdv" (click)="redirectToRDV(event)" title="Modifier le RDV"></button> -->
    </div>
</div>
